interface SidebarProps {
  side: 'left' | 'right';
  width?: string;
  children: React.ReactNode;
  className?: string;
}

export function Sidebar({ side, width = 'w-56', children, className = '' }: SidebarProps) {
  const borderClass = side === 'left' ? 'border-r' : 'border-l';

  return (
    <aside
      className={`hidden md:block ${width} shrink-0 ${borderClass} border-line-subtle bg-clyra-raised overflow-y-auto ${className}`}
    >
      {children}
    </aside>
  );
}

interface SidebarSectionProps {
  title: string;
  children: React.ReactNode;
}

export function SidebarSection({ title, children }: SidebarSectionProps) {
  return (
    <div className="p-3">
      <h3 className="mb-2 text-micro font-semibold uppercase tracking-wider text-ink-muted">
        {title}
      </h3>
      {children}
    </div>
  );
}
